module.exports = __webpack_public_path__ + "img/9791185184036.1277336e.jpg";